import styled, { css } from 'styled-components';
import { Link, Tag, isMobileStyleMixin } from '@amzn/storm-ui';

const wrapInlineValueMixin = /*#__PURE__*/css(["display:inline;text-wrap:wrap;word-break:break-all;margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.xxxsmall.default);
const KeyValueWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-vxkbml-0"
})(["display:inline-block;text-align:start;align-items:center;> *{vertical-align:middle;}"]);
const KeyText = /*#__PURE__*/styled.label.withConfig({
  componentId: "sc-storm-ui-40027066__sc-vxkbml-1"
})(["", ";color:", ";font:", ";", ";"], wrapInlineValueMixin, ({
  theme,
  disabled
}) => disabled ? theme.text.color.unavailable : theme.text.color.default, ({
  theme
}) => theme.font.text.medium.default, isMobileStyleMixin(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
const ValueTextUrl = /*#__PURE__*/styled(Link).withConfig({
  componentId: "sc-storm-ui-40027066__sc-vxkbml-2"
})(["", ";"], wrapInlineValueMixin);
const CustomTag = /*#__PURE__*/styled(Tag).withConfig({
  componentId: "sc-storm-ui-40027066__sc-vxkbml-3"
})(["", ";font:", ";", ";"], wrapInlineValueMixin, ({
  theme
}) => theme.font.text.medium.default, isMobileStyleMixin(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));

export { CustomTag as C, KeyText as K, ValueTextUrl as V, KeyValueWrapper as a };
//# sourceMappingURL=KeyValueAttribute.styles-BN5d50Io.js.map
